import React from "react";
import DeactivatePage from "../Components/DeactivatePage";
function DeactivatePageContainer() {
  return (
    <>
      <DeactivatePage />
    </>
  );
}
export default DeactivatePageContainer;
